import { render, staticRenderFns } from "./showInstalledPlugins.vue?vue&type=template&id=3094fae1&scoped=true"
import script from "./showInstalledPlugins.vue?vue&type=script&lang=js"
export * from "./showInstalledPlugins.vue?vue&type=script&lang=js"
import style0 from "./showInstalledPlugins.vue?vue&type=style&index=0&id=3094fae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094fae1",
  null
  
)

export default component.exports